import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './style.css'
import App from './App.vue'
import router from './router'
import reveal from './directives/reveal'
// 动态创建 link 标签引入 Font Awesome
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css'
document.head.appendChild(link)

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
/* 注册 v-reveal：元素滚动进入视口时淡入上移，见 src/directives/reveal.js */
app.directive('reveal', reveal)

app.mount('#app')
